import {Component, ContentChild, Renderer2, HostBinding} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {SvgIcon} from '@valg-shared/utils/svg-icon';
import { InputType } from '../root/input-type';

let NEXT_ID = 0;

@Component({
  selector: 'valg-form-password',
  templateUrl: './password.component.html'
})
export class FormPasswordComponent {
  public id: string = 'valg-form-password-' + NEXT_ID++;
  buttonText: string = 'standard_input.password.button.show';
  showPassword = false;
  @HostBinding('class') class: string = "valg-form-password";
  
  @ContentChild(InputType, { static: false }) public inputElement!: InputType;

  readonly SvgIcon = SvgIcon;
 
  constructor(
    protected translate: TranslateService,
    protected renderer: Renderer2
  ) {
  }

  togglePasswordState(){
    this.showPassword = !this.showPassword;
    if(this.inputElement){
      this.inputElement.setAttribute({"name": "type", "value": this.showPassword ? "text": "password"});
    }
    
    this.buttonText = this.showPassword ? 'standard_input.password.button.hide': 'standard_input.password.button.show';
  }

  blurButton($event: FocusEvent | undefined){
    let nextFocus = $event?.relatedTarget as Element;
    if(nextFocus.id !== this.inputElement.getAttribute('id')){
      this.inputElement.focusOut.emit($event);
    }
  }
}